import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Initialize Firebase — single instance shared across the app
const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)

export const functions = getFunctions(app)

if (import.meta.env.VITE_EMULATE_AUTH === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
}
if (import.meta.env.VITE_EMULATE_FIRESTORE === 'true') {
  connectFirestoreEmulator(db, 'localhost', 8080)
}
if (import.meta.env.VITE_EMULATE_FUNCTIONS === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

export const features = {
  enableBilling: import.meta.env.VITE_ENABLE_BILLING === "true",
  enableVspRpa: import.meta.env.VITE_ENABLE_VSP_RPA === "true",
}
